export default __webpack_public_path__ + "static/media/Bdome.9e465656.png";